import { locationHistory } from '../location'
import { describeTable } from './describeTable'

describeTable(locationHistory, {
  description: `GPS points reported for an entity. Empty in production: nothing writes here any more (the table is a leftover of an earlier tracking idea), so there is no location data to analyse. Designed as employees (entity_type='employee', entity_id=employees.id) while out on visits, optionally tagged with the property they were at. Order by created_at for a track. No business figure derives from this table, and the current backend has no active writer for it, so expect sparse or legacy data — do not use it to infer visit attendance or working time (use visit_attendees and hour_sheets).`,
  columns: {
    entityType: "Polymorphic type, e.g. 'employee'.",
    entityId: 'Id in the entity_type table.',
    accuracy: 'Reported GPS accuracy in metres.',
    speed: 'Metres per second as reported by the device.',
    heading: 'Compass heading in degrees.',
    source: "How the fix was obtained: 'gps', 'network' or 'manual'.",
    metadata: 'Free JSON from the reporting device.',
    propertyId: 'The property the point was recorded at, when known.',
  },
})
